export default __webpack_public_path__ + "static/media/logo-endless.8ec7e65f.svg";